export const STORAGE_PREFIX = 'fiek-met'

export const getLanguage = () => {
  return localStorage.getItem(`${STORAGE_PREFIX}-language`) || 'hu'
}

export const setLanguage = (language) => {
  localStorage.setItem(`${STORAGE_PREFIX}-language`, language)
}
